@if (isExtended) {
<div class="extended-row">
    <div class="extended-cell right-border-devider">
        <span [class]="`extended-label expansion-panel-header-label ${labelsClass}`" i18n-title title="Transport Order Nr" i18n>Transport Order Nr</span>
        <span [class]="`extended-value ${textClass}`" [title]="this.getHeaderItemValue('transportOrderNumber', defaultValue)">
            {{ this.getHeaderItemValue('transportOrderNumber', defaultValue) }}
        </span>
    </div>
    <div class="extended-cell extended-cell--narrow  right-border-devider">
        <span [class]="`extended-label expansion-panel-header-label ${labelsClass}`" i18n-title title="Tour Nr" i18n>Tour Nr</span>
        <span [class]="`extended-value ${textClass}`" [title]="this.getHeaderItemValue('tourNumber', defaultValue)">
            {{ this.getHeaderItemValue('tourNumber', defaultValue) }}
        </span>
    </div>
    <div class="extended-cell extended-cell--narrow right-border-devider">
        <span [class]="`extended-label expansion-panel-header-label ${labelsClass}`" i18n-title title="Vehicle" i18n>Vehicle</span>
        <span [class]="`extended-value ${textClass}`" [title]="this.getHeaderItemValue('truckLicensePlate', '-')">
            {{ this.getHeaderItemValue('truckLicensePlate', '-') }}
        </span>
    </div>
    <div class="extended-cell extended-cell--narrow right-border-devider">
        <span [class]="`extended-label expansion-panel-header-label ${labelsClass}`" i18n-title title="Trailer" i18n>Trailer</span>
        <span [class]="`extended-value ${textClass}`" [title]="this.getHeaderItemValue('trailerLicensePlate', '-')">
            {{ this.getHeaderItemValue('trailerLicensePlate', '-') }}
        </span>
    </div>
    <div class="extended-cell right-border-devider">
        <span [class]="`extended-label expansion-panel-header-label ${labelsClass}`" i18n-title title="Driving Instructions" i18n>Driving Instructions</span>
        <span [class]="`extended-value ${textClass}`" [title]="this.getHeaderItemValue('driveInstructions', defaultValue)">
            {{ this.getHeaderItemValue('driveInstructions', defaultValue) }}
        </span>
    </div>
    <div class="extended-cell right-border-devider">
        <span [class]="`extended-label expansion-panel-header-label ${labelsClass}`" i18n-title title="Transport Mode" i18n>Transport Mode</span>
        <span [class]="`extended-value ${textClass}`" [title]="this.getHeaderItemValue('transportMode', defaultValue)">
            {{ this.getHeaderItemValue('transportMode', defaultValue) }}
        </span>
    </div>
    <div class="extended-cell right-border-devider">
        <span [class]="`extended-label expansion-panel-header-label ${labelsClass}`" i18n-title title="Status" i18n>Status</span>
        <span [class]="`extended-value ${textClass}`" [title]="this.getHeaderItemValue('status', defaultValue)">
            {{ this.getHeaderItemValue('status', defaultValue) }}
        </span>
    </div>
    <div class="extended-cell extended-cell--fixed right-border-devider">
        <div class="extended-truck relative flex items-start w-[57px]">
            <lib-app-icon icon="truck_sections_icon" size="30x60" class="relative truck-icon"/>
            <input type="text" aria-label="chamber 3 temperature" [value]="transportOrderCopy.chamber3Temperature?.toString() || ''"
                class="!absolute mt-[6px] ml-[2px] w-[14px] h-[14px] text-[10px] bg-transparent justify-items-center font-medium" readonly />
            <input type="text" aria-label="chamber 2 temperature" [value]="transportOrderCopy.chamber2Temperature?.toString() || ''"
                class="!absolute mt-[6px] ml-[18px] w-[14px] h-[14px] text-[10px] bg-transparent justify-items-center font-medium" readonly />
            <input type="text" aria-label="chamber 1 temperature" [value]="transportOrderCopy.chamber1Temperature?.toString() || ''"
                class="!absolute mt-[6px] ml-[34px] w-[14px] h-[14px] text-[10px] bg-transparent justify-items-center font-medium" readonly />
        </div>
    </div>
    <div class="extended-cell extended-cell--fixed right-border-devider">
        <app-chip
            [content]="transportOrderCopy.numberOfTourpoints?.toString() || '0'"
            [iconNames]="['location_icon']"
            className="flex items-center rounded-[20px] border-solid number-of-locations-border"
        />
    </div>
    <div class="extended-cell extended-cell--fixed" [class.right-border-devider]="this.isLocked">
        <div class="grid">
            <div class="flex gap-1">
                <lib-app-icon icon="shelves" [class]="`${textClass}`" [size]="'16x16'"/>
                <span [class]="`text-xs ${labelsClass}`">{{this.getHeaderItemValue("plannedVolumePalletSpaces", '0')}}</span>
                <span [class]="`text-xs ${labelsClass}`" i18n>VSP</span>
            </div>
            <div class="flex gap-1">
                <lib-app-icon icon="weight_icon" [class]="`${textClass}`" [size]="'16x16'"/>
                <span [class]="`text-xs ${labelsClass}`">{{this.getHeaderItemValue("weight", '0')}}</span>
                <span [class]="`text-xs ${labelsClass}`" i18n>kg</span>
            </div>
        </div>
    </div>
    @if(this.isLocked) {
    <div class="extended-cell extended-cell--fixed">
        <lib-locked-indicator
            size="40"
            [tooltipMessage]="lockedTooltipMessage"
        />
    </div>
    }
</div>
} @else {
<div [class]="wrapperClassName">
    <div class="flex mt-1">
        <div class="compact-column flex flex-col items-start mr-2 w-max">
            <span [class]="labelClassName" aria-label="order number" i18n-title title="Transport Order Nr" i18n>Transport Order Nr</span>
            <span [class]="textClassName" [title]="this.getHeaderItemValue('transportOrderNumber', defaultValue)" aria-label="order number">
                {{ this.getHeaderItemValue('transportOrderNumber', defaultValue) }}
            </span>
        </div>
        <!-- <div class="flex flex-col items-start mr-2 w-max">
            <span class="expansion-panel-header-label text-xs leading-tight" aria-label="tour Number" i18n>Tour Nr</span>
            <span class="text-sm leading-tight font-bold max-w-[80px] truncate" [title]="this.getHeaderItemValue('tourNumber', '--:-- ----')" aria-label="tourNumber">
                {{ this.getHeaderItemValue('tourNumber', "--:-- ----") }}
            </span>
        </div> -->
        <div class="compact-column flex flex-col items-start mr-2 w-max">
            <span [class]="labelClassName" aria-label="Vehicle" i18n-title title="Vehicle" i18n>Vehicle</span>
            <span [class]="textClassName" [title]="this.getHeaderItemValue('truckLicensePlate', defaultValue)" aria-label="Vehicle">
                {{ this.getHeaderItemValue('truckLicensePlate', '-') }}
            </span>
        </div>
        <div class="compact-column flex flex-col items-start mr-2 w-max">
            <span [class]="labelClassName" aria-label="Trailer" i18n-title title="Trailer" i18n>Trailer</span>
            <span [class]="textClassName" [title]="this.getHeaderItemValue('trailerLicensePlate', '-')" aria-label="Trailer">
                {{ this.getHeaderItemValue('trailerLicensePlate', '-') }}
            </span>
        </div>
        <div class="compact-column flex flex-col items-start mr-2 w-max">
            <span [class]="labelClassName" aria-label="Driving Instructions" i18n-title title="Driving Instructions" i18n>Driving Instructions</span>
            <span [class]="textClassName" [title]="this.getHeaderItemValue('driveInstructions', defaultValue)" aria-label="Driving Instructions">
                {{ this.getHeaderItemValue('driveInstructions', defaultValue) }}
            </span>
        </div>
        <div class="compact-column flex flex-col items-start mr-2 w-max">
            <span [class]="labelClassName" aria-label="Transport Mode" i18n-title title="Transport Mode" i18n>Transport Mode</span>
            <span [class]="textClassName" [title]="this.getHeaderItemValue('transportMode', defaultValue)" aria-label="Transport Mode">
                {{ this.getHeaderItemValue('transportMode', defaultValue) }}
            </span>
        </div>
        <div class="compact-column flex flex-col items-start mr-2 w-max">
            <span [class]="labelClassName" aria-label="Status" i18n-title title="Status" i18n>Status</span>
            <span [class]="textClassName" [title]="this.getHeaderItemValue('status', defaultValue)" aria-label="Transport Mode">
                {{ this.getHeaderItemValue('status', defaultValue) }}
            </span>
        </div>
    </div>
    <div class="flex mt-1">
        <div class="relative flex items-start w-[57px] mr-3 mt-1">
            <lib-app-icon icon="truck_sections_icon" size="30x60" class="relative truck-icon"/>
             <input type="text" aria-label="order number" [value]="transportOrderCopy.chamber3Temperature?.toString() || ''"
                    class="!absolute mt-[6px] ml-[2px] w-[14px] h-[14px] text-[10px] bg-transparent justify-items-center font-medium" readonly />
            <input type="text" aria-label="order number" [value]="transportOrderCopy.chamber2Temperature?.toString() || ''"
                    class="!absolute mt-[6px] ml-[18px] w-[14px] h-[14px] text-[10px] bg-transparent justify-items-center font-medium" readonly />
            <input type="text" aria-label="order number" [value]="transportOrderCopy.chamber1Temperature?.toString() || ''"
                    class="!absolute mt-[6px] ml-[34px] w-[14px] h-[14px] text-[10px] bg-transparent justify-items-center font-medium" readonly />
        </div>
        <div class="flex flex-col items-start mr-2 w-max">
            <app-chip
                [content]="transportOrderCopy.numberOfTourpoints?.toString() || '0'"
                [iconNames]="['check_icon']"
                class="mt-1 mr-2"
                className="flex items-start rounded-[20px] border-solid number-of-locations-border"
            />
        </div>
        <div class="grid">
            <div class="flex gap-1">
                <lib-app-icon icon="shelves" [class]="`${textClass}`" [size]="'16x16'"/>
                <span [class]="`text-xs ${this.labelsClass}`">{{this.getHeaderItemValue("plannedVolumePalletSpaces", '0')}}</span>
                <span [class]="`text-xs ${labelsClass}`" i18n>VSP</span>
            </div>
            <div class="flex gap-1">
                <lib-app-icon icon="weight_icon" [class]="`${textClass}`" [size]="'16x16'"/>
                <span [class]="`text-xs ${labelsClass}`" >{{this.getHeaderItemValue("weight", '0')}}</span>
                <span [class]="`text-xs ${labelsClass}`"  i18n>kg</span>
            </div>
        </div>
    </div>
    @if(this.isLocked) {
        <lib-locked-indicator
            class="lock-icon"
            size="40"
            [tooltipMessage]="lockedTooltipMessage"
        />
    }
</div>
}
